<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>学习计划</span><span>/</span><span>
        <router-link to="/Company/Plan">计划管理</router-link>
      </span><span>/</span><span>{{ruleForm.id?(disabled?'查看':'编辑'):'新建'}}试卷</span>
    </div>
    <div class="comUserInfo" v-loading="loading">
      <div class="comUserInfo-header">
        <el-button type="primary" v-if="!disabled" @click="onSave">保存</el-button>
        <el-button type="primary" v-if="disabled" @click="goBack">返回</el-button>
      </div>
      <div class="comUserInfo-conts">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm"
          style="width: 773px;margin: 20px 0px 20px 40px;text-align: left;padding-bottom: 50px;">
          <el-form-item label="试卷名称：" prop="cname">
            <el-input :disabled="disabled" v-model="ruleForm.cname" placeholder="请输入试卷名称"></el-input>
          </el-form-item>
          <el-form-item label="试卷简介：">
            <el-input type="textarea" :disabled="disabled" :rows="2" placeholder="请输入试卷简介"
              v-model="ruleForm.description">
            </el-input>
          </el-form-item>
          <el-form-item label="试卷题型分类：" prop="parentid" style="display: inline-block;width: 50%;">
            <el-select :disabled="true" @change="getParName" v-model="ruleForm.parentid" placeholder="请选择试卷题型分类"
              style="width: 100%;">
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                  :value="item.uniqueCode">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：" prop="state" label-width="100px" style="display: inline-block;width: 49%;">
            <el-radio-group v-model="ruleForm.state">
              <el-radio :disabled="disabled" v-for="(k,i) in 2" :label="i" :value="i" :key="i">{{i==0?'不生效':'生效'}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="试卷规则：" prop="kstype" style="display: inline-block;width: 50%;">
            <el-radio-group v-model="ruleForm.kstype">
              <el-radio :disabled="disabled" v-for="(k,i) in 2" :label="k" :value="k" :key="k">{{k==1?'固定':'随机'}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="难度：" prop="clevel" label-width="100px" style="display: inline-block;width: 49%;">
            <el-select :disabled="disabled" v-model="ruleForm.clevel" placeholder="请选择难度类型" style="width: 100%;">
              <el-option v-for="item in clevel" :key="item.val" :label="item.text" :value="item.val"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="考试地点：" prop="kcplace" style="display: inline-block;width: 50%;">
            <el-input :disabled="disabled" v-model="ruleForm.kcplace" placeholder="请输入考试地点"></el-input>
          </el-form-item>
          <el-form-item label="人员数量：" class="sjsc" label-width="100px" style="display: inline-block;width: 49%;">
            <el-input-number :disabled="disabled" style="width: 100%;text-align: left;" v-model="ruleForm.cyrynum"
              placeholder="请输入可参与人员数量" :precision="0" :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="考试时长/分钟：" class="sjsc" style="display: inline-block;width: 50%;"
            :rules="[{ required: true, message: '考试时长不能为空'}]">
            <el-input-number :disabled="disabled" style="width: 100%;text-align: left;" v-model="ruleForm.sjsc"
              placeholder="请输入考试时长" :precision="0" :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="及格分数：" class="sjsc" label-width="100px" style="display: inline-block;width: 49%;">
            <el-input-number :disabled="disabled" style="width: 100%;text-align: left;" v-model="ruleForm.passfenshu"
              placeholder="请输入及格分数" :precision="0" :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="单选题数量/分数：">
            <el-input-number :disabled="disabled" :min="0" v-model="ruleForm.itype1Amount" placeholder="单选题数量"
              :precision="0">
            </el-input-number>
            <el-input-number :disabled="disabled" :min="0" v-model="ruleForm.itype1Fraction" placeholder="每个单选题分数"
              :precision="1"></el-input-number>
          </el-form-item>
          <el-form-item label="多选题数量/分数：">
            <el-input-number :disabled="disabled" :min="0" v-model="ruleForm.itype2Amount" placeholder="多选题数量"
              :precision="0">
            </el-input-number>
            <el-input-number :disabled="disabled" :min="0" v-model="ruleForm.itype2Fraction" placeholder="每个多选题分数"
              :precision="1"></el-input-number>
          </el-form-item>
          <el-form-item label="判断题数量/分数：">
            <el-input-number :disabled="disabled" :min="0" v-model="ruleForm.itype3Amount" placeholder="判断题数量"
              :precision="0">
            </el-input-number>
            <el-input-number :disabled="disabled" :min="0" v-model="ruleForm.itype3Fraction" placeholder="每个判断题分数"
              :precision="1"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        rules: {
          cname: [{
            required: true,
            message: '试卷名称不能为空',
            trigger: 'blur'
          }],
          parentid: [{
            required: true,
            message: '分类不能为空',
            trigger: 'blur'
          }],
          clevel: [{
            required: true,
            message: '难度不能为空',
            trigger: 'blur'
          }],
          itype: [{
            required: true,
            message: '试卷类型不能为空',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: '状态不能为空',
            trigger: 'blur'
          }],
          kstype: [{
            required: true,
            message: '试卷类型不能为空',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          itype1Amount: 0,
          itype1Fraction: 0,
          itype2Amount: 0,
          itype2Fraction: 0,
          itype3Amount: 0,
          itype3Fraction: 0,
          itype4Amount: 0,
          itype4Fraction: 0,
          itype5Amount: 0,
          itype5Fraction: 0,
          kstype: 1,
          isPlan: 1
        },
        dalists: [{
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }],
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        loading: false,
        itype: [{
          val: 1,
          text: '单选'
        }, {
          val: 2,
          text: '多选'
        }, {
          val: 3,
          text: '判断'
        }],
        clevel: [{
          val: 1,
          text: '简单'
        }, {
          val: 2,
          text: '一般'
        }, {
          val: 3,
          text: '困难'
        }],
        kstype: [{
            id: 1,
            text: '日常考试'
          }
          // , {
          //   id: 2,
          //   text: '规定时间考试'
          // },
        ],
        rangTime: [],
        disabled: false
      }
    },
    methods: {
      onSave: function() {
        var $this = this;
        this.loading = true;
        this.ruleForm.isPlan = 1;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            var url = '/kt/ktPapersSet/add.htm';
            if (this.ruleForm.id) {
              url = '/kt/ktPapersSet/update.htm';
            };
            delete this.ruleForm.createTime;
            delete this.ruleForm.startDate;
            delete this.ruleForm.endDate;

            delete this.ruleForm.list;
            delete this.ruleForm.creator;
            delete this.ruleForm.createName;

            if (this.$route.query.currid) {
              this.ruleForm.productid = this.$route.query.currid;
            }

            this.$axios.post(url, this.$qs.stringify(this.ruleForm))
              .then(res => {
                var data = res.data;
                this.loading = false;
                if (data.stat == '1') {
                  this.$message({
                    message: '试题保存成功！',
                    type: 'success',
                    duration: 1000,
                    onClose: function() {
                      $this.$router.push('/Company/MyCurriculum');
                    }
                  });
                } else {
                  this.$message.error(data.message);
                }
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      goBack: function() {
        this.$router.go(-1);
      },
      getData: function(id) {
        this.$axios.get('/kt/ktPapersSet/getByCurrId.htm?currId=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data.stat == '1') {
            this.ruleForm = data.data;
            this.getParName(data.data.parentid);
          } else {
            this.$message.error(data.message);
          }
        })
      },
      // 获取培训类别名称
      getParName: function(val) {
        var list = [];
        if (val.indexOf('ZXKT_producttype_2') >= 0) {
          list = this.options[0].children
        } else {
          list = this.options[1].children
        };
        list.map((item) => {
          if (item.uniqueCode == val) {
            this.$set(this.ruleForm, 'parentname', item.text);
          }
        });
      }
    },
    created: function() {
      // 试卷详情
      if (this.$route.query.id) {
        this.loading = true;
        this.disabled = this.$route.query.isck == '1'
        this.getData(this.$route.query.id);
      } else {
        this.$set(this.ruleForm, 'parentid', this.$route.query.ontype);
        this.getParName(this.$route.query.ontype);
      }
      getItype(this.$axios, ((res) => {
        this.options = res;
      }));

      // 滚动条滚动到最顶部
      $('#app').animate({
        scrollTop: 110
      }, 300);

      // this.$set(this.ruleForm,'cid',this.currentUser.cid);
    },
    components: {}
  }
</script>
<style>
  .comUserInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comUserInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }

  .avatar {
    width: 100px;
    height: 140px;
  }

  .sjsc .el-input-number .el-input__inner {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Addexam.vue